// Core imports
import * as React from 'react';
import i18n from 'src/translation/i18n';
import { commentsRegEx } from 'src/utils/RegexUtils';
import './PackageNeverArrivedMoreInfo.scss';

// utils regex
import { emailcapsRegEx } from 'src/utils/RegexUtils';

class PackageNeverArrivedMoreInfo extends React.Component<IPackageNeverArrivedMoreInfoProps, any> {
  constructor(props: IPackageNeverArrivedMoreInfoProps) {
    super(props);
  }
 
  public render() {
    return (
      <div style={{ marginBottom: '10px'}}>
        <h4>{i18n.t('warrantyView.moreInfo')}</h4>
        <div className="form-row row  ">
          <div className={`form-group col-sm-12 col-md-6 col-lg-12 mb ${this.props.DamageErrormsgshow && this.props.DamageIsPackageDeliverd==='' ? 'error-border' : ''}`}>
              <label>
                {i18n.t('partClaim.carrierText')}
                </label>
                    <div className='claim-radio-contaner'>
                    <div>
                    <input
                    id="radio1"
                    name="isPackageDeliverd"
                    type="radio"
                    value={"Yes"}
                    checked={this.props.DamageIsPackageDeliverd === "Yes"}
                    onChange={e => this.props.handleRadioChange(e)}
                  />
                  <label>Yes</label>
                  </div>
                  <div>
                  <input
                    id="radio1"
                    name="isPackageDeliverd"
                    type="radio"
                    value={"No"}
                    checked={this.props.DamageIsPackageDeliverd === "No"}
                    onChange={e => this.props.handleRadioChange(e)}
                  />
                  <label>No</label>
                  </div>
                  <div>
                  <input
                    id="radio1"
                    name="isPackageDeliverd"
                    type="radio"
                    value={"Not Sure"}
                    checked={this.props.DamageIsPackageDeliverd === "Not Sure"}
                    onChange={e => this.props.handleRadioChange(e)}
                  />
                  <label>Not Sure</label>
          </div>
              </div>
          </div>

        {this.props.DamageIsPackageDeliverd === "Yes" &&
          <div className="form-group col-sm-12 col-md-6 col-lg-12 mb">
              <div>
                  <label>{i18n.t('warrantyView.qtyWarning')}:
                    <span className="required">*</span>
                  </label>
              </div>
              <div className='qty-box'>
                <input
                className=
                {`form-control-claims ${
                  this.props.DamageIsPackageDeliverd === "Yes" && this.props.DamageNoPackageReceived==='' || this.props.DamageErrorlistservice?.DamagePackageReceivedError
                    ? 'form-control-error-border'
                    : ''
                }`}
                name="noPackageReceived"
                id="radio1"
                type="number"
                pattern="[1-9]*"
                value={this.props.DamageNoPackageReceived}
                onChange={e => this.props.handleQtyValue(e)}
              />
               {this.props.DamageErrorlistservice &&
                <span className="rp-warranty-input-error-internal">
                  {this.props.DamageErrorlistservice?.DamagePackageReceivedError
                    ? ` ${i18n.t('partClaim.invalidQty')}`
                    : ''}
                </span>
                }
              </div>
          </div>
        }

          <div className="form-group col-sm-12 col-md-6 col-lg-12 mb">
              <div>
                  <label>{i18n.t('warrantyView.claimResolutionText')}:</label>
              </div>
              <div className='description-box'>
                <input
                className='form-control-claims'
                name="addtionalComment"
                type="text"
                value={this.props.DamageAdditionalComment}
                onChange={e => this.props.handleAdditionalComment(e)}
              />
             
<div>
                    {this.props.DamageErrorlistservice
                      ?.DamageAdditionalCommentError ? (
                        this.props.DamageErrorlistservice === '' ? (
                        <span className="rp-warranty-input-error-internal">
                          {i18n.t('partClaim.reqfield')}
                        </span>
                      ) : !/\S/.test(this.props.DamageErrorlistservice) ? (
                        <span className="rp-warranty-input-error-internal">
                          {i18n.t('partClaim.atleastchar')}
                        </span>
                      ) : this.props.DamageErrorlistservice.length > 250 ? (
                        !commentsRegEx.test(this.props.DamageErrorlistservice) ? (
                          <>
                            <span className="rp-warranty-input-error-internal">
                              {i18n.t('damageClaim.maxeigchar')}
                            </span>
                            <p className="rp-warranty-input-error-internal">
                              {i18n.t('partClaim.tracknumerror')}(
                              {i18n.t('partClaim.noSymbols')})
                            </p>
                          </>
                        ) : (
                          <span className="rp-warranty-input-error-internal">
                            ({i18n.t('damageClaim.maxeigchar')})
                          </span>
                        )
                      ) : (
                        <span className="rp-warranty-input-error-internal">
                          {i18n.t('partClaim.tracknumerror')}(
                          {i18n.t('partClaim.noSymbols')})
                        </span>
                      )
                    ) : (
                      <span className="input-info">
                        <i>
                          {' '}
                          ({i18n.t('damageClaim.maxeigchar')}){''}
                          {i18n.t('partClaim.tracknumerror')}(
                          {i18n.t('partClaim.noSymbols')})
                        </i>{' '}
                      </span>
                    )}
                  </div>
              </div>
          </div>
          
        </div>
      </div>
    );
  }
}

export default PackageNeverArrivedMoreInfo;

interface IPackageNeverArrivedMoreInfoProps {
  DamageIsPackageDeliverd: string;
  DamageNoPackageReceived: string;
  DamageAdditionalComment: string;
  DamageErrorlistservice: any;
  DamageErrormsgshow: boolean;
  handleAdditionalComment: (event: any) => void;
  handleQtyValue: (event: any) => void;
  handleRadioChange: (event: any) => void;
}
